export function Skeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: rows }).map((_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: simple static skeleton rows
        <div key={i} className="skeleton-line" />
      ))}
    </div>
  );
}
